<template>
    <div>
        <el-alert title="目前仅支持最多2年的数据，点击具体的类型可查看明细" show-icon type="warning"></el-alert>
        <div class="page-filter-box MT10">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="14" :lg="11" :xl="8">
                    <el-date-picker
                        v-model="datetimerange"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="日期"
                        end-placeholder="日期"
                        size="small"
                        value-format="yyyy-MM-dd"
                        :clearable="false"
                        style="width:100%"
                        unlink-panels
                        >
                    </el-date-picker>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <!-- <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button> -->
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="timeStr" label="日期" min-width="150"></el-table-column>
                <el-table-column prop="totalNum" label="总热度"></el-table-column>
                <el-table-column>
                    <template slot="header">
                        <router-link :to="`/report/sales/show?timeStart=${params.rangeStart}&timeEnd=${params.rangeEnd}`">演出销售</router-link>
                    </template>
                    <template slot-scope="scope">
                        <router-link :to="`/report/sales/show?timeStart=${scope.row.timeStr} 00:00:00&timeEnd=${scope.row.timeStr} 23:59:59`">{{scope.row.activityOrderNum}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column>
                    <template slot="header">
                        <router-link :to="`/report/sales/crowdfunding?timeStartStr=${params.rangeStart}&timeEndStr=${params.rangeEnd}`">众筹销售</router-link>
                    </template>
                    <template slot-scope="scope">
                        <router-link :to="`/report/sales/crowdfunding?timeStartStr=${scope.row.timeStr} 00:00:00&timeEndStr=${scope.row.timeStr} 23:59:59`">{{scope.row.raiseOrderNum}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column>
                    <template slot="header">
                        <router-link :to="`/report/sales/surrounding?timeStart=${params.rangeStart}&timeEnd=${params.rangeEnd}`">周边销售</router-link>
                    </template>
                    <template slot-scope="scope">
                        <router-link :to="`/report/sales/surrounding?timeStart=${scope.row.timeStr} 00:00:00&timeEnd=${scope.row.timeStr} 23:59:59`">{{scope.row.goodsOrderNum}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column>
                    <template slot="header">
                        <router-link :to="`/report/hot/activity/collect?rangeStart=${params.rangeStart}&rangeEnd=${params.rangeEnd}`">演出收藏</router-link>
                    </template>
                    <template slot-scope="scope">
                        <router-link :to="`/report/hot/activity/collect?rangeStart=${scope.row.timeStr} 00:00:00&rangeEnd=${scope.row.timeStr} 23:59:59`">{{scope.row.activityCollectsNum}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column>
                    <template slot="header">
                        <router-link :to="`/report/hot/raise/collect?rangeStart=${params.rangeStart}&rangeEnd=${params.rangeEnd}`">众筹收藏</router-link>
                    </template>
                    <template slot-scope="scope">
                        <router-link :to="`/report/hot/raise/collect?rangeStart=${scope.row.timeStr} 00:00:00&rangeEnd=${scope.row.timeStr} 23:59:59`">{{scope.row.raiseCollectsNum}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column>
                    <template slot="header">
                        <router-link :to="`/report/hot/live/subscribe?rangeStart=${params.rangeStart}&rangeEnd=${params.rangeEnd}`">直播预约</router-link>
                    </template>
                    <template slot-scope="scope">
                        <router-link :to="`/report/hot/live/subscribe?rangeStart=${scope.row.timeStr} 00:00:00&rangeEnd=${scope.row.timeStr} 23:59:59`">{{scope.row.liveReserveNum}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column>
                    <template slot="header">
                        <router-link :to="`/report/hot/live/watch?rangeStart=${params.rangeStart}&rangeEnd=${params.rangeEnd}`">直播观看</router-link>
                    </template>
                    <template slot-scope="scope">
                        <router-link :to="`/report/hot/live/watch?rangeStart=${scope.row.timeStr} 00:00:00&rangeEnd=${scope.row.timeStr} 23:59:59`">{{scope.row.liveWatchNum}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column>
                    <template slot="header">
                        <router-link :to="`/report/hot/join/activity?rangeStart=${params.rangeStart}&rangeEnd=${params.rangeEnd}`">参加活动</router-link>
                    </template>
                    <template slot-scope="scope">
                        <router-link :to="`/report/hot/join/activity?rangeStart=${scope.row.timeStr} 00:00:00&rangeEnd=${scope.row.timeStr} 23:59:59`">{{scope.row.shareActivityUserNum}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column>
                    <template slot="header">
                        <router-link :to="`/report/hot/video/play?rangeStart=${params.rangeStart}&rangeEnd=${params.rangeEnd}`">视频播放</router-link>
                    </template>
                    <template slot-scope="scope">
                        <router-link :to="`/report/hot/video/play?rangeStart=${scope.row.timeStr} 00:00:00&rangeEnd=${scope.row.timeStr} 23:59:59`">{{scope.row.videoPlayNum}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column>
                    <template slot="header">
                        <router-link :to="`/report/hot/video/praise?rangeStart=${params.rangeStart}&rangeEnd=${params.rangeEnd}`">视频点赞</router-link>
                    </template>
                    <template slot-scope="scope">
                        <router-link :to="`/report/hot/video/praise?rangeStart=${scope.row.timeStr} 00:00:00&rangeEnd=${scope.row.timeStr} 23:59:59`">{{scope.row.videoPraiseNum}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column>
                    <template slot="header">
                        <router-link :to="`/report/hot/video/comment?rangeStart=${params.rangeStart}&rangeEnd=${params.rangeEnd}`">视频评论</router-link>
                    </template>
                    <template slot-scope="scope">
                        <router-link :to="`/report/hot/video/comment?rangeStart=${scope.row.timeStr} 00:00:00&rangeEnd=${scope.row.timeStr} 23:59:59`">{{scope.row.videoCommentNum}}</router-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
const defaultParams = {
    pageNo:1,
    rangeStart:'',
    rangeEnd:'',
    // timeStart: "00:00:00",
    // timeEnd: "23:59:59"
}
export default {
    data(){
        const endTime = this.$utils.formatDate( (new Date().getTime()), 'yyyy-MM-dd' );
        const startTime = this.$utils.formatDate( (new Date().getTime() - 3600 * 1000 * 24 * 7), 'yyyy-MM-dd' );
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageSize: this.$pageSizes[0]
            },
            listLoading: false,    
            datetimerange: [this.$route.query.rangeStart || startTime, this.$route.query.rangeEnd || endTime],
        }
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            if( !this.datetimerange || this.datetimerange.length < 1 ){
                this.$message.error('请选择查询时间段')
                return;
            }
            const _timeRang = new Date( this.datetimerange[1] ) - new Date( this.datetimerange[0] );
            const _yearRang = parseInt(_timeRang / 24 / 3600 / 1000);
            if( _yearRang > 730 ){
                this.$message.error('目前仅支持最多2年的数据');
                return;
            }
            this.listLoading = true;
            this.params = {
                ...this.params,
                rangeStart:this.datetimerange ? this.datetimerange[0] + ' 00:00:00' : null,
                rangeEnd:this.datetimerange ? this.datetimerange[1] + ' 23:59:59' : null
            }
            this.$request({
                url: "/hot/statistics/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
    }
}
</script>

<style lang="scss" scoped>
.el-table{
    a{
        display: block;
        color: $--color-theme;
        &:hover{
            text-decoration: underline;
        }
    }
}
</style>